import React from "react";
import Modal from "@components/atoms/Modal";
import { CollectionMenuItem } from "@src/types/models";
import BulkActionsContent from "./BulkActionsContent";

type BulkActionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  menuOptions: Array<CollectionMenuItem>;
  itemCount: number;
  selectOption: any;
  totalItems: number;
};

const BulkActionsModal = ({
  isOpen,
  onClose,
  menuOptions,
  itemCount,
  selectOption,
  totalItems,
}: BulkActionModalProps) => {
  return (
    <Modal
      headerTitle={`${itemCount === 0 ? `No` : itemCount} Items Selected`}
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={1}
      paddingRight={1}
      paddingBottom={40}
      paddingTop={1}
    >
      <BulkActionsContent
        itemCount={itemCount}
        totalItems={totalItems}
        menuOptions={menuOptions}
        selectOption={selectOption}
      />
    </Modal>
  );
};

export default BulkActionsModal;
